import { useState, useCallback, useMemo, useEffect } from 'react';
import { postStaffCsvImport, Error, getImportHistory } from 'api/staff';
import useToastNotification from 'hooks/useToastNotification';
import { UploadType } from './StaffCsvUploadForm';

export const useOrganizationCsvForm = () => {
  // アップロードタイプ
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [uploadType, setUploadType] = useState<UploadType>('0');
  const { successNotification, errorNotification } = useToastNotification();
  const [importHistory, setImportHistory] = useState([]);
  const [blocking, setBlocking] = useState(false);

  const uploadTypeItems: Array<{ label: string, value: UploadType }> = useMemo(() => ([
    {
      label: 'スタッフ情報',
      value: '0',
    },
    {
      label: 'マネージャー権限',
      value: '2',
    },
    {
      label: '介護・看護休暇情報',
      value: '1',
    },
  ]), []);

  // アップロードファイル
  const [uploadFile, setUploadFile] = useState<File>();

  // アップロードエラー
  const [errors, setErrors] = useState<Array<string>>(); 

  if (uploadFile) {
    const fileType = uploadFile.type;
    if (fileType !== 'text/csv'
    && fileType !== 'application/vnd.ms-excel'
    && fileType !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    && fileType !== 'text/xls'
    && fileType !== 'text/xlsx'
    ) {
      // errorNotification('CSVファイルを選択してください。');
      setErrors(['CSVファイルを選択してください。']);
      setUploadFile(undefined);
    }
  }

  // アップロード実行処理
  const onSubmit = useCallback(() => {
    if (!uploadFile) {
      return;
    }

    if (!confirmModalOpen) {
      setConfirmModalOpen(true);
      return;
    }

    // エラー表示を初期化
    setErrors(undefined);
    setConfirmModalOpen(false);
    setBlocking(true);
    postStaffCsvImport(uploadType, uploadFile).then((response) => {
      if (response.status !== 200) {
        let errorString = '';
        (response.data.errors as Array<Error>).map((err) => {
          errorString += `${err.defaultMessage} \n`;
          return errorString;
        });
        // setErrors((response.data.errors as Array<Error>).map((err) => err.defaultMessage));
        errorNotification(errorString);
      } else {
        successNotification('インポートが完了しました。');
      }
      setUploadFile(undefined);
      setBlocking(false);
    }).catch((error) => { 
      setUploadFile(undefined);
      if (error.response.status !== 200) {
        let errorString = '';
        (error.response.data.errors as Array<Error>).map((err) => {
          errorString += `${err.defaultMessage} \n`;
          return errorString;
        });
        setErrors((error.response.data.errors as Array<Error>).map((err) => err.defaultMessage));
      } else {
        successNotification('インポートが完了しました。');
      }
      setBlocking(false);
    });
  }, [confirmModalOpen, errorNotification, successNotification, uploadFile, uploadType]);

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  useEffect(() => {
    setBlocking(true)
    getImportHistory().then((response: any) => {
      setImportHistory(response);
      setBlocking(false)
    });
  }, [])

  return {
    confirmModalOpen,
    closeConfirmModal,
    uploadType,
    setUploadType,
    uploadTypeItems,
    uploadFile,
    setUploadFile,
    onSubmit,
    errors,
    blocking,
    importHistory,
    setImportHistory,
  };
};

export default {};
